// extracted by mini-css-extract-plugin
module.exports = {"root":"CodeInput_root__m1Ty7","inputsContainer":"CodeInput_inputsContainer__2mujn","input":"CodeInput_input__3ZVjk","timer":"CodeInput_timer__2GRsW"};